import { render, staticRenderFns } from "./goldsilvermovesettleHistory.vue?vue&type=template&id=730e878f&scoped=true&"
import script from "./goldsilvermovesettleHistory.vue?vue&type=script&lang=js&"
export * from "./goldsilvermovesettleHistory.vue?vue&type=script&lang=js&"
import style0 from "./goldsilvermovesettleHistory.vue?vue&type=style&index=0&id=730e878f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e878f",
  null
  
)

export default component.exports